"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMReportId = void 0;
exports.getEMReportIds = getEMReportIds;
exports.getEMReportIdFrom = getEMReportIdFrom;
var EMReportId;
(function (EMReportId) {
    EMReportId["StudentLevelReport"] = "em-student-level-report";
    EMReportId["SummaryReport"] = "em-summary-report";
    EMReportId["ParticipationReport"] = "em-participation-report";
    EMReportId["StandardReport"] = "em-standard-report";
})(EMReportId || (exports.EMReportId = EMReportId = {}));
function getEMReportIds() {
    return Object.values(EMReportId);
}
function getEMReportIdFrom(value) {
    return getEMReportIds().find(function (type) { return type === value; });
}
